var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59375 15.6562C4.40625 17.4688 7.34375 17.4688 9.15625 15.6562C10.8438 13.9688 13.5938 11.2188 15.2812 9.53125C15.4375 9.375 15.4375 9.15625 15.2812 9L14.75 8.46875C14.5938 8.3125 14.375 8.3125 14.2188 8.46875C12.5312 10.1562 9.78125 12.9062 8.09375 14.5938C6.875 15.8125 4.875 15.8125 3.65625 14.5938C2.4375 13.375 2.4375 11.375 3.65625 10.1562L10.6875 3.125C11.5 2.3125 12.8125 2.3125 13.625 3.125C14.4375 3.9375 14.4375 5.25 13.625 6.0625L7.71875 11.9688C7.3125 12.375 6.65625 12.375 6.25 11.9688C5.875 11.5938 5.875 10.9375 6.25 10.5312L11.2812 5.53125C11.4375 5.375 11.4375 5.15625 11.2812 5L10.75 4.46875C10.5938 4.3125 10.375 4.3125 10.2188 4.46875L5.21875 9.46875C4.21875 10.4688 4.21875 12.0625 5.21875 13.0312C6.1875 14.0312 7.78125 14.0312 8.75 13.0312L14.6875 7.125C16.0938 5.71875 16.0938 3.46875 14.6875 2.0625C13.2812 0.65625 11.0312 0.65625 9.625 2.0625L2.59375 9.09375C0.78125 10.9062 0.78125 13.8438 2.59375 15.6562Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPdf);
export default __webpack_public_path__ + "static/media/PinPdf.abc579592bd5c9d43b084b7d6cfc3cd0.svg";
export { ForwardRef as ReactComponent };